








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TeamUserSummary extends Vue {
  @Prop() private category!: string;
  @Prop() private data!: any;

  get lessonTitle() {
    return this.data && this.data.LessonTitle ? this.data.LessonTitle : 'No Data';
  }

  get exerciseTitle() {
    return this.data && this.data.ExerciseTitle ? this.data.ExerciseTitle : 'No Data';
  }
}
